import ShipperOrderTableHeader from './styled';

export default ShipperOrderTableHeader;
